import EditableTextDetailRowContainer from "./EditableTextDetailRowContainer";

export { genDetailRowComponents } from "./genDetailRowComponents/v1";
export { genDetailRowComponentsV2 } from "./genDetailRowComponents/v2";

export default EditableTextDetailRowContainer;
